var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSubscriptionPaymentMethod = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 6,
    fill: "#DDECFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25542_14280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.66699 19H31.667M11.667 13H29.667C30.7716 13 31.667 13.8954 31.667 15V27C31.667 28.1046 30.7716 29 29.667 29H11.667C10.5624 29 9.66699 28.1046 9.66699 27V15C9.66699 13.8954 10.5624 13 11.667 13Z",
    stroke: "#6B7DE5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25542_14280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8.66699 9)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSubscriptionPaymentMethod);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_subscription_payment_method.5890282f0b4e6e00f2959255c5cf8e8b.svg";